import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const DynamicImageComponent = ({ imageName }) => {

  const data = useStaticQuery(graphql`
    query MyQuery {
      allFile(filter: {extension: {regex: "/(jpg|jpeg|png)/"}}) {
        nodes {
          relativePath
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
      }
    }
  `);

  const image = getImage(data?.allFile?.nodes.find(file => file.relativePath === imageName)?.childImageSharp?.gatsbyImageData);

  if (image) {
    return <GatsbyImage image={image} alt={imageName.replace(/[^a-zA-Z0-9]/g, "")} />
  }

  return null;
};

export default DynamicImageComponent;
